export default __webpack_public_path__ + "static/media/spacerace1.154cd919.png";